import { useEffect, useRef } from 'react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { fetchDashboard } from '@/api/fleet';

const POLL_INTERVAL = 60_000; // 60 seconds normal polling
const INITIAL_FALLBACK_DELAY = 1_500;

export function useDashboard() {
  const updateStats = useDashboardStore((s) => s.updateStats);
  const isLoaded = useDashboardStore((s) => s.isLoaded);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    let mounted = true;

    const poll = async () => {
      try {
        const stats = await fetchDashboard();
        if (!mounted) return;
        updateStats(stats);
      } catch {
        // ignore
      }
      if (mounted) {
        timerRef.current = setTimeout(poll, POLL_INTERVAL);
      }
    };

    timerRef.current = setTimeout(
      poll,
      isLoaded ? POLL_INTERVAL : INITIAL_FALLBACK_DELAY
    );

    return () => {
      mounted = false;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isLoaded, updateStats]);
}
